import { UIButton } from "@src/components/UIButton";
import UIModal from "@src/components/UIModal/UIModal";
import React from "react";

interface ChangeToReadyAlertProps {
  closeModal: () => void;
  isOpen: boolean;
  openModal: () => void;
  toggleModal: () => void;
  onConfirm: () => void;
  /**
   * Disables the confirm button while the status change is in flight. The modal
   * stays mounted during its 250ms fade-out, so without this the button remains
   * clickable after confirming and a second click fires a duplicate request.
   */
  isConfirming?: boolean;
}

const ChangeToReadyAlert: React.FC<ChangeToReadyAlertProps> = ({
  closeModal,
  isOpen,
  onConfirm,
  isConfirming,
}) => {
  return (
    <UIModal
      actions={[
        <UIButton key="cancel" onClick={closeModal} className="secondary">
          Cancel
        </UIButton>,
        <UIButton key="confirm" onClick={onConfirm} disabled={isConfirming}>
          Confirm
        </UIButton>,
      ]}
      isOpen={isOpen}
      title="Change to Ready"
      onClose={closeModal}
    >
      <p>Are you sure you want to change this playlist status to Ready?</p>
    </UIModal>
  );
};

export default ChangeToReadyAlert;
